import { render, staticRenderFns } from "./RecentNearMatchSummary.vue?vue&type=template&id=5326b070&scoped=true&"
import script from "./RecentNearMatchSummary.vue?vue&type=script&lang=js&"
export * from "./RecentNearMatchSummary.vue?vue&type=script&lang=js&"
import style0 from "./RecentNearMatchSummary.vue?vue&type=style&index=0&id=5326b070&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5326b070",
  null
  
)

export default component.exports